import Barrel from "../../model/Barrel";
import permissions from "../permissions";
import { isOrganizationProject } from "../legacy";

/**
 * Checks whether barrel user is permitted to move resources (colors, textStyles or componentSections)
 *
 * Permissions for moving resources from a barrel is defined as:
 * Free plan: Owner
 * Personal plans: Project and styleguide members
 * Organization: Editors and above
 *
 * @param {import("../../model/Barrel").default} barrel
 * @param {Object} barrelUser
 */
export default function canMoveResources(
    barrel: Barrel,
    barrelUser: { role: string; user: { _id: string; };}
): boolean {
    // If organization, check permissions definitions in util
    if (isOrganizationProject(barrel)) {
        return permissions.canMoveResources(barrelUser);
    }

    const barrelOwner = barrel.users.find(user => user.role === "owner")!;
    const ownerPlan = barrelOwner.user.paymentPlan;

    // Only owner can move resources in free plan
    if (ownerPlan === "free") {
        return barrelUser.user._id === barrelOwner.user._id;
    }

    // Project and styleguide members can move in personal plans
    return permissions.canMoveResources(barrelUser);
}
